;(function () {
  'use strict'

  angular
    .module('contrast.score-settings')
    .controller('ScoreSettingsCtrl', [
      '$scope',
      '$translate',
      'dialogs',
      'TEAMSERVER_SCORING_TYPE',
      'ScoreSettingsService',
      'SCORE_SETTINGS_ALL_OPTION',
      'permissions',
      ScoreSettingsCtrl
    ])

  function ScoreSettingsCtrl(
    $scope,
    $translate,
    dialogs,
    TEAMSERVER_SCORING_TYPE,
    ScoreSettingsService,
    SCORE_SETTINGS_ALL_OPTION,
    permissions
  ) {
    var translGlobal = {
      title_pleaseConfirmAction: $translate.instant(
        'title_pleaseConfirmAction'
      ),
      action_switch: $translate.instant('action_switch'),
      action_cancel: $translate.instant('action_cancel'),
      detail_scoreSettings_switchSettingsConfirmation: $translate.instant(
        'detail_scoreSettings_switchSettingsConfirmation'
      )
    }

    var _config = {
      confirmModal: {
        title: translGlobal.title_pleaseConfirmAction,
        message: translGlobal.detail_scoreSettings_switchSettingsConfirmation,
        settings: {
          size: 'md',
          yes: translGlobal.action_switch,
          no: translGlobal.action_cancel
        }
      }
    }

    angular.extend($scope, {
      libraryPolicyIsSet: libraryPolicyIsSet,
      save: save,
      showOverallLanguageSelect: showOverallLanguageSelect,
      overallLanguagesChanged: overallLanguagesChanged,
      isLanguageOptionLocked: isLanguageOptionLocked
    })

    function _setDefaults() {
      angular.extend($scope, {
        model: {
          disabled: false,
          overall: {
            typeOptions: TEAMSERVER_SCORING_TYPE.OVERALL,
            type: TEAMSERVER_SCORING_TYPE.OVERALL.DEFAULT
          },
          library: {
            typeOptions: TEAMSERVER_SCORING_TYPE.LIBRARY,
            type: TEAMSERVER_SCORING_TYPE.LIBRARY.DEFAULT
          },
          selectedOverallLanguages: []
        }
      })
    }

    function init() {
      _setDefaults()
      ScoreSettingsService.getInitData().then(function (data) {
        $scope.model.disabled =
          data.overrideEnabled === false ||
          !permissions.hasPermission('RULES_ADMIN')

        $scope.model.library.type = data.scorePolicy.libraryScoreType
        $scope.model.failLibrariesPolicy = data.scorePolicy.failLibrariesPolicy
        $scope.model.overall.type = data.scorePolicy.overallScoreType

        $scope.model.availableLanguages = data.availableLanguages
        $scope.model.activeLanguageOptions = data.availableLanguages
        _syncSelectedOverallLanguagesWithRequestData(
          data.scorePolicy.overallScoreLanguages
        )
      })
    }

    function _syncSelectedOverallLanguagesWithRequestData(request) {
      if (!request) {
        _setAllOptionOnly()
      } else if (angular.isArray(request) && request.length) {
        var availableLanguages = $scope.model.availableLanguages
        var keys = Object.keys(availableLanguages)
        request.forEach(function (langString) {
          _findLanguageObjectByValue(langString, keys, availableLanguages)
        })
        $scope.model.activeLanguageOptions = $scope.model.availableLanguages
      }
    }

    function _findLanguageObjectByValue(langString, keys, availableLanguages) {
      var key
      for (var i = 0; i < keys.length; i++) {
        key = keys[i]
        if (availableLanguages[key].value == langString) {
          $scope.model.selectedOverallLanguages.push(availableLanguages[key])
          break
        }
      }
    }

    function libraryPolicyIsSet() {
      return $scope.model.failLibrariesPolicy
    }

    function save() {
      var config = _config.confirmModal
      dialogs
        .confirm(config.title, config.message, config.settings)
        .result.then(function () {
          var requestBody = {
            libraryScoreType: $scope.model.library.type,
            overallScoreType: $scope.model.overall.type
          }
          if (
            requestBody.overallScoreType ==
            TEAMSERVER_SCORING_TYPE.OVERALL.CUSTOM_ONLY
          ) {
            requestBody.overallScoreLanguages =
              _getSelectedOverallLanguagesAsCommaDelimitedList().join(',')
          }
          return requestBody
        })
        .then(ScoreSettingsService.update)
        .then(init)
        .then(function () {
          $scope.form.$dirty = false
        })
    }

    function showOverallLanguageSelect() {
      return (
        $scope.model.overall.type == TEAMSERVER_SCORING_TYPE.OVERALL.CUSTOM_ONLY
      )
    }

    function overallLanguagesChanged() {
      if (_noneSelected() || _areAllSelected()) {
        _setAllOptionOnly()
      } else {
        _removeAllOption()
      }
    }

    function isLanguageOptionLocked(name) {
      return name == SCORE_SETTINGS_ALL_OPTION.name
    }

    function _setAllOptionOnly() {
      $scope.model.selectedOverallLanguages = [SCORE_SETTINGS_ALL_OPTION]
    }

    function _removeAllOption() {
      $scope.model.selectedOverallLanguages =
        $scope.model.selectedOverallLanguages.filter(function (obj) {
          return obj.value != SCORE_SETTINGS_ALL_OPTION.value
        })
    }

    function _areAllSelected() {
      return (
        $scope.model.selectedOverallLanguages.length ==
        $scope.model.availableLanguages.length
      )
    }

    function _noneSelected() {
      return !$scope.model.selectedOverallLanguages.length
    }

    function _isAllOption() {
      return $scope.model.selectedOverallLanguages.find(function (lang) {
        return lang.value == SCORE_SETTINGS_ALL_OPTION.value
      })
    }

    function _getSelectedOverallLanguagesAsCommaDelimitedList() {
      if (_isAllOption()) {
        return []
      } // empty list means all to the endpoint
      return $scope.model.selectedOverallLanguages.map(function (obj) {
        return obj.value
      })
    }

    init()
  }
})()
